export const config = {
    // baseURL: 'https://apis.odibets.com/api/v2/',
    baseURL: 'https://api.odi.site/api/v2/',
    baseURLWEB: 'https://odashapi.ridgeways.xyz/api/v3/',
    baseURLGhana: 'http://34.78.77.38/v1/',
    // Proxy endpoint (HTTPS) that forwards to the internal replay service.
    // Frontend will call: https://api.odi.site/replay/{matchUrn}/{producerId}
    replayBaseURL: 'https://api.odi.site/',
    host: 'example.com',
};